import React from 'react'

const shippingData = [
    {
        icon: "ph-fill ph-car-profile",
        title: "Free Shipping",
        text: "Free shipping all over the US"
    },
    {
        icon: "ph-fill ph-hand-heart",
        title: "100% Satisfaction",
        text: "Free shipping all over the US"
    },
    {
        icon: "ph-fill ph-credit-card",
        title: "Secure Payments",
        text: "Free shipping all over the US"
    },
    {
        icon: "ph-fill ph-chats",
        title: "24/7 Support",
        text: "Free shipping all over the US"
    }
];

const ShippingOne = () => {
    return (
        <section className="shipping mb-24" id="shipping">
            <div className="container container-lg">
                <div className="row gy-4">

                    {shippingData.map((item, index) => (
                        <div className="col-xxl-3 col-sm-6" key={index}>
                            <div className="shipping-item flex-align gap-16 rounded-16 bg-main-50 hover-bg-main-100 transition-2 text-white hover-text-dark">
                                <span className="w-56 h-56 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                                    <i className={item.icon} />
                                </span>
                                <div>
                                    <h6 className="mb-0">{item.title}</h6>
                                    <span className="text-sm">
                                        {item.text}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
        </section>
    )
}

export default ShippingOne;
